import { IRowNode } from 'ag-grid-enterprise';
import { ExtendedRowNode } from '../types';

type CellParams = {
  column?: { getColId: () => string } | null;
  colDef?: { field?: string | null } | null;
  node?: IRowNode | null;
};

const getFieldKey = (params: CellParams): string =>
  params.colDef?.field ?? params.column?.getColId() ?? '';

const getValidationError = (params: CellParams): string | undefined => {
  const fieldKey = getFieldKey(params);
  return (
    (params.node as ExtendedRowNode | undefined)?._cellErrors?.[fieldKey] ||
    undefined
  );
};

export const cellOperations = {
  getValidationError,
};
